import { filterLaunchAreas } from "./filter-launch-areas";

type NamedLaunchArea = {
  Id: string;
  Name: string;
};

type IsShotFromSelectedLaunchAreaInput = {
  bayName: string | undefined;
  launchAreas: NamedLaunchArea[] | undefined;
  selectedLaunchAreaIds: string[] | undefined;
};

// TODO: Switch this check from BayName to BayId (matched against LaunchArea.Id)
// once the radar websocket payload includes a real launch-area id. Today BayId
// is always the zero UUID, so name matching is the only available signal and
// can collide if two launch areas share a Name.
export const isShotFromSelectedLaunchArea = ({
  bayName,
  launchAreas,
  selectedLaunchAreaIds,
}: IsShotFromSelectedLaunchAreaInput): boolean => {
  if (!selectedLaunchAreaIds) {
    return true;
  }

  if (!bayName) {
    return false;
  }

  return filterLaunchAreas(launchAreas ?? [], selectedLaunchAreaIds).some(
    (area) => area.Name === bayName
  );
};
